import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { CompaniesService } from '../../services/companies.service';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.css']
})
export class CompaniesComponent implements OnInit {
  companies: any = [];
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private companiesService: CompaniesService,
    private commonService: CommonService
  ) {
  }

  ngOnInit() {
    this.getCompanies();
  }


  getCompanies(): void {
    console.log('component get Companies');
    this.companiesService.getCompanies()
      .then(response => {
        this.companies = response;
        console.log('this companies : ', this.companies);
      });
  }
}



// WEBPACK FOOTER //
// D:/projects/passengerControlFront/passengerControlApp/src/app/components/companies/companies.component.ts